<template>
	<el-badge :value="value" type="info">
		<el-button v-bind="{...$attrs, type}" :disabled="isDisabled" :icon="iconOnRight ? undefined : icon" @click="$emit('click', $event)">
			<template v-if="showLabel">
				{{ LocalizedPopisostatni }}
				<i v-if="iconOnRight" :class="icon" class="el-icon-right" />
			</template>
			<slot />
		</el-button>
	</el-badge>
</template>

<script>
import { DmsBaseComponent } from '#components/dms/common/base';
import { BUTTON_TYPES } from '#components/@types/button';

export default DmsBaseComponent.extend({
	name: 'DmsBadgeButton',
	props: {
		value: [String, Number],
		text: String,
		icon: String,
		iconOnRight: Boolean,
		type: {
			type: String,
			in: BUTTON_TYPES,
		},
	},
	computed: {
		LocalizedPopisostatni() {
			return this.text || this.LocalizePopisostatni(this.labelKey);
		},
		showLabel() {
			return !!(this.labelKey || this.text);
		},
	},
});
</script>

<style lang="scss">
	.el-badge {
		.el-badge__content {
			z-index: 10;
			font-size: 11px;
			padding: 0 6px;
			font-weight: bold;
			background-color:#4E5163;
			height: 20px;
			&.is-fixed {
				right: 17px;
			}
		}
	}
	.el-badge + .el-badge, .el-badge + .el-button, .el-button + .el-badge {
		margin-left: 10px;
	}
</style>
